module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/wechat-document-title-316.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/wechat/wechat-document-title.md
// module id = 784
// module chunks = 190